import { useEffect, useState } from "react"
import { useGalleryInfiniteQuery } from "@/service/api/gallery"
import type { ListRequest } from "@/shared/types/commonResponse"
import ListHeader from "@/components/custom/ListHeader"
import { useNavigate } from "react-router-dom"
import { STAR_ID } from "@/shared/constants/star"
import { InfiniteScrollTrigger } from "@/components/etc/InfiniteScrollTrigger"

const GalleryList = () => {
  const navigate = useNavigate()
  const [galleryList, setGalleryList] = useState<ListRequest>({
    Language: "en",
    angkorId: "",
    requestDto: {
      pageable: {
        page: 0,
        size: 15,
        sort: [],
      },
      searchKeyword: "",
      starId: STAR_ID,
    },
  })

  const {
    data: galleryListData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useGalleryInfiniteQuery(galleryList)

  const items = galleryListData?.pages.flatMap((page) => page.content) ?? []
  const slimItems = items.map(({ id, imageUrl }) => ({ id, imageUrl }))

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <div>
        <ListHeader title="Gallery" />
        <div className="grid overflow-y-auto grid-cols-3 pt-14">
          {items.map((item, index) => (
            <button
              onClick={() => {
                navigate(`${item.id}`, {
                  state: { galleryList: slimItems },
                })
              }}
              key={index}
              className="w-full shrink-0 aspect-square"
            >
              <img
                src={item.imageUrl}
                alt="Gallery Image"
                className="object-cover w-full h-full"
                loading="lazy"
              />
            </button>
          ))}

          <InfiniteScrollTrigger
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            onLoadMore={fetchNextPage}
          />
        </div>
      </div>
    </>
  )
}

export default GalleryList
